import * as types from '../actiontypes';
import {
	createApiAction,
	deleteSCOTJournalSourceUrl,
	getAllJournalSourceUrl,
	postSCOTJournalSourceUrl,
	updateJournalSourceUrl
} from '../apiUrls';

export const getAllJournalSources = (engagementId, trackWithArea = undefined) => {
	const url = getAllJournalSourceUrl(engagementId);

	return createApiAction(types.GET_JOURNAL_SOURCE, url, 'GET', undefined, trackWithArea, {resolve: true});
};

export const getJournalSourcesWithQueries = (engagementId, queryStringParameters, trackWithArea = undefined) => {
	const url = getAllJournalSourceUrl(engagementId, queryStringParameters);

	return createApiAction(types.GET_JOURNAL_SOURCE, url, 'GET', undefined, trackWithArea, {resolve: true});
};

export const postSCOTJournalSource = (engagementId, data) => {
	const url = postSCOTJournalSourceUrl(engagementId);

	return createApiAction(types.POST_SCOT_JOURNAL_SOURCE, url, 'POST', data, undefined, {resolve: true});
};

export const deleteSCOTJournalSource = (engagementId, SCOTJournalSource) => {
	const url = deleteSCOTJournalSourceUrl(engagementId, SCOTJournalSource.id);

	return createApiAction(types.DELETE_SCOT_JOURNAL_SOURCE, url, 'DELETE', undefined, undefined, {SCOTJournalSource});
};

export const updateJournalSource = (engagementId, journalSourceId, data) => {
	const url = updateJournalSourceUrl(engagementId, journalSourceId);

	return createApiAction(types.UPDATE_JOURNAL_SOURCE, url, 'PUT', data, undefined, {resolve: true});
};

export const updateHasRelatedSCOT = (engagementId, journalSourceId, data) => {
	const url = updateJournalSourceUrl(engagementId, journalSourceId);

	return createApiAction(types.UPDATE_JOURNAL_SOURCE_RELATED_SCOT, url, 'PUT', data, undefined, {resolve: true});
};

export const updateCustomName = (engagementId, journalSourceId, data) => {
	const url = updateJournalSourceUrl(engagementId, journalSourceId);

	return createApiAction(types.UPDATE_JOURNAL_SOURCE_CUSTOM_NAME, url, 'PUT', data, undefined, {resolve: true});
};
